import ApiClient from "../helpers/ApiClient";


export const addCSRProject = async (formDataToSend) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/csrProjects`,
            formDataToSend,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCSRProjects = async (params = {}) => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/csrProjects`, { params });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCSRProjectById = async (id) => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/csrProjects/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editCSRProject = async (id, formDataToSend) => {  //Receive id and FormData
    try {
        const response = await ApiClient.patch(`/researchandstudentlife/csrProjects/${id}`,
            formDataToSend,  //Send FormData
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response  edit", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteCSRProject = async (id) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/csrProjects/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}
